import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "bg-gray-700 rounded-lg p-4 mb-6 shadow-inner" }
const _hoisted_2 = { class: "flex justify-between items-start mb-2" }
const _hoisted_3 = { class: "bg-gray-900 rounded-full w-10 h-10 flex items-center justify-center mr-3 shadow-md" }
const _hoisted_4 = { class: "text-blue-400 font-bold" }
const _hoisted_5 = { class: "text-blue-400 font-medium" }
const _hoisted_6 = { class: "text-blue-400 text-sm" }
const _hoisted_7 = { class: "mt-2 flex items-center" }
const _hoisted_8 = { class: "flex items-center mr-4" }
const _hoisted_9 = { class: "text-green-400 mr-1" }
const _hoisted_10 = { class: "flex items-center" }
const _hoisted_11 = { class: "text-red-400 mr-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "text-blue-400 font-semibold" }, "Prodavac", -1)),
      (!_ctx.isCurrentUserProductOwner)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleReportClick && _ctx.handleReportClick(...args))),
            class: "text-gray-400 hover:text-red-400 transition-colors text-sm flex items-center"
          }, _cache[1] || (_cache[1] = [
            _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              class: "h-4 w-4 mr-1",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("path", { d: "M11 17h1m0 0h1m-1 0v-4m8-6-8-4-8 4m16 0v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7m14-2v10" })
            ], -1),
            _createTextVNode(" Prijavi ")
          ])))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_router_link, {
      to: {
        name: 'profile',
        params: { id: _ctx.product.user.id },
      },
      class: "flex items-center hover:bg-gray-600 p-2 rounded-md transition-colors"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.product.user.username.charAt(0).toUpperCase()), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.product.user.username), 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.product.user.city), 1)
        ])
      ]),
      _: 1
    }, 8, ["to"]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("span", _hoisted_9, "+" + _toDisplayString(_ctx.product.user.positiveRatings), 1),
        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-gray-400" }, "pozitivnih", -1))
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("span", _hoisted_11, "-" + _toDisplayString(_ctx.product.user.negativeRatings), 1),
        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-gray-400" }, "negativnih", -1))
      ])
    ])
  ]))
}